import ContactModel from "./ContactModel";
import _ from "underscore";
import Backbone from "backbone";
import Tracking from "../utils/Tracking";
import RecaptchaHandler from "../utils/RecaptchaHandler";

let Leaflet = require("leaflet");
require("backbone.stickit");
require("backbone-validator.js");

module.exports = Backbone.View.extend({
    el: $(".view-contact__form"),

    initialize: function(options) {
        _.extend(this, options);
        if (typeof Zmaps === "function") {
            this.initMap();
        }

        this.model = new ContactModel({
            trans: options.trans
        });
        this.render();

        this.listenTo(this.model, "change", this.triggerSingleValidation);
    },

    render: function () {
        this.bindValidation(); // Attach model validation's events to the view
        this.addContactOptionsBindings(this.contactOptions);
        this.stickit(); // Stickit bindings

        if (typeof this.formToken !== "undefined" && !_.isEmpty(this.formToken)) {
            this.model.set({
                token: this.formToken
            });
        }
    },

    events: {
        "submit": "save"
    },

    bindings: {
        "[name='contact[voornaam]']": "voornaam",
        "[name='contact[naam]']": "naam",
        "[name='contact[tel_nr]']": "tel_nr",
        "[name='contact[gsm_nr]']": "gsm_nr",
        "[name='contact[email]']": "email",
        "[name='contact[text]']": "text",
        "[name='contact[verlangt_andere_communicatie]']": "verlangt_andere_communicatie", // not required
        "[name='contact[token]']": "token"
    },

    addContactOptionsBindings: function (contactOptions) {
        let that = this;
        if (typeof contactOptions !== "undefined" && !_.isEmpty(contactOptions)) {
            _.each(contactOptions, function(cp) {
                that.addBinding(null, "[name='contact[" + cp.field + "]']", cp.field);
            });
        }
    },

    onValidField: function(attrName) {
        this.$el
            .find("[name='contact[" + attrName + "]']")
            .parents(".form-group")
            .removeClass("has-error");

        // tel/gsm is zo een beetje speciaal zo, dus moet iets speciaals doen voor de label zo
        if (_.contains(["tel_nr", "gsm_nr"], attrName)) {
            this.$el.find(".contact_tel_nr").removeClass("error-label");
        }
    },

    onInvalidField: function(attrName) {
        this.$el
            .find("[name='contact[" + attrName + "]']")
            .parents(".form-group")
            .addClass("has-error");

        // tel/gsm is zo een beetje speciaal zo, dus moet iets speciaals doen voor de label zo
        if (_.contains(["tel_nr", "gsm_nr"], attrName)) {
            this.$el.find(".contact_tel_nr").addClass("error-label");
        }
    },

    initMap: function() {
        let gmapContainer = $('.gmap');
        window.maps = gmapContainer;

        gmapContainer.each((key, el) => {
            let $canvas = $(el),
                officeLat = $canvas.data("geolat"),
                officeLng = $canvas.data("geolong");

            if (
                (typeof officeLat === "undefined" || officeLat === "" || officeLat === null || parseInt(officeLat) === 0) ||
                (typeof officeLng === "undefined" || officeLng === "" || officeLng === null || parseInt(officeLng) === 0)
            ) {
                return false;
            }

            let zmapView = new Zmaps({
                    el: el,
                    zoom: 18,
                    center: {
                        lat: officeLat,
                        lng: officeLng
                    },
                    closePopupOnClick: false,
                    fullscreenControl: false
                });

            zmapView.initMap();
            if (typeof ZmapMarker === "function") {
                this.addMarker(zmapView.map, officeLat, officeLng);
            }
        });

    },

    addMarker: function (map, lat, lng) {
        let myIcon = Leaflet.icon({
            iconUrl: '/public/img/pointer.png',
            iconAnchor: [20, 52],
            iconSize: [40, 52]
        });

        let marker = new ZmapMarker(map, {
            icon: myIcon
        });
        marker
            .addMarker([lat, lng]);
    },

    save: function(e) {
        e.preventDefault();
        if (!this.model.isValid()) {
            let errors = this.model.validate();
            this.showValidationPopup(errors);
            return false;
        }
        let buttonEl = this.$el.find("#contact-submit");
        buttonEl
            .addClass("disabled")
            .attr("disabled", "disabled");

        let that = this;
        RecaptchaHandler.handle(
            this.model.toJSON(),
            function (data) {
                that.send(data);
            }
        );
    },

    send: function (data) {
        let buttonEl = this.$el.find("#contact-submit");
        $.ajax({
            type: "POST",
            url: base_dir + '/' + url_language + '/ajax/contact-form/',
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify(data),
            success: () => {
                bootbox_message_box(this.trans.form_success, "success");
                buttonEl
                    .removeClass("disabled")
                    .removeAttr("disabled");
                if (typeof _gaq === "object") {
                    _gaq.push(['_trackEvent', 'Contact', 'sent', 'contact page', , true ]);
                }
                Tracking.fbTrackEvent("Contact page sent");
            },
            error: (data) => {
                if (typeof data.responseJSON !== "undefined" && typeof data.responseJSON.data !== "undefined") {
                    this.showValidationPopup(data.responseJSON.data);
                }
                buttonEl
                    .removeClass("disabled")
                    .removeAttr("disabled");
            }
        });
    },

    showValidationPopup: function(errors) {
        let errorHTML = "";
        if (_.isArray(errors) || _.isObject(errors)) {
            errorHTML += "<ul>\n";
            _.each(errors, function(item) {
                if (_.isArray(item) || _.isObject(item)) {
                    errorHTML += "<li>" + item[0] + "</li>\n";
                } else {
                    errorHTML += "<li>" + item + "</li>\n";
                }
            });
            errorHTML += "</ul>\n";
        } else {
            errorHTML = "<p>" + errors + "</p>";
        }
        bootbox_message_box(errorHTML, "error");
    },

    triggerSingleValidation: function(model, item) {
        let changedItem = null;

        // only validate item that is being changed
        if (
            typeof item.stickitChange !== "undefined" &&
            typeof item.stickitChange.observe !== "undefined" &&
            item.stickitChange.observe !== ""
        ) {
            changedItem = item.stickitChange.observe
        }
        this.model.validate(changedItem);
    }

});
